import { render, staticRenderFns } from "./UserSettingsPage.vue?vue&type=template&id=4c180eb7"
import script from "./UserSettingsPage.vue?vue&type=script&lang=js"
export * from "./UserSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports